<template>
  <input
    v-model="internalDate"
    type="date"
    class="p-2 rounded-l-none rounded-r-md"
    :max="today"
    :min="minDate"
    @change="onChange"
  />
</template>

<script>
export default {
  props: {
    date: {
      type: String,
      required: true,
    },
    today: {
      type: String,
      required: true,
    },
    minDate: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      internalDate: this.date,
    };
  },
  watch: {
    date(newVal) {
      this.internalDate = newVal;
    },
  },
  methods: {
    onChange() {
      this.$emit('date-changed', this.internalDate);
    },
  },
};
</script>
